/* KAARKASH editorial search.
   The panel of the header: opened by the glass on the bar (the click is taken before the
   theme's own search window hears it), it shows a few pieces until a word is typed, then
   the searches that word could be and the pieces it finds, asking the store a quarter of a
   second after the last key. Only the answer to the last question asked is ever shown.
   The line at the head of the search page: "Clear" empties it. */
(function () {
  'use strict';
  if (window.__kkSearch) { window.__kkSearch.scan(); return; }

  var WAIT = 250;                 // after the last key, before the store is asked
  var SLIDE = 400;                // the panel's own time, as in the stylesheet
  var FOUND = 'kk-predictive-search';
  var TRENDING = 'kk-search-trending';
  var COUNT = 'kk-search-count';
  // the last word typed may be the start of a longer one; what cannot be bought comes last
  var LAST = '&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last';
  var GLASS = '.kkhd .header__search > details > summary, [data-kkhd-search]';
  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var box = null, opener = null, typing = 0, closing = 0, asked = 0, pending = null, trending = false;

  function part(name) { return box ? box.querySelector('[data-kksr-' + name + ']') : null; }
  function header() { return document.querySelector('.section-header'); }
  function say(text) { var s = part('status'); if (s) s.textContent = text; }
  function address(base, query) { return base + (base.indexOf('?') > -1 ? '&' : '?') + query; }
  // photographs already in the browser's keeping arrive before anyone listens for them
  function fade(scope) { if (window.__kkPage) window.__kkPage.images(scope); }

  /* ---------- opening and closing ---------- */
  function place() {
    var bar = document.querySelector('.section-header .header-wrapper');
    var top = bar ? Math.max(0, Math.round(bar.getBoundingClientRect().bottom)) : 0;
    box.style.setProperty('--kksr-top', top + 'px');
  }
  function mark(open) {
    var h = header();
    if (h) h.classList.toggle('kksr-open', open);
    html.classList.toggle('kksr-is-open', open);
    document.querySelectorAll(GLASS).forEach(function (el) {
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (el.hasAttribute('data-kkhd-search')) el.setAttribute('aria-label', open ? 'Close search' : 'Search');
    });
  }
  function open(from) {
    if (!box || box.classList.contains('is-open')) return;
    clearTimeout(closing);
    opener = from || document.activeElement;
    if (window.__kkHeader) { window.__kkHeader.closeAll(); window.__kkHeader.closeMenu(true); }
    place();
    box.removeAttribute('hidden');
    void box.offsetWidth;                             // commit the shut state so the panel eases in
    box.classList.add('is-open');
    mark(true);
    var input = part('input');
    if (input) input.focus({ preventScroll: true });
    showTrending();
  }
  function close(keepFocus) {
    if (!box || !box.classList.contains('is-open')) return;
    box.classList.remove('is-open');
    mark(false);
    clearTimeout(typing);
    if (pending) { pending.abort(); pending = null; }
    var mine = box;
    closing = setTimeout(function () { if (!mine.classList.contains('is-open')) mine.setAttribute('hidden', ''); }, reduce.matches ? 160 : SLIDE);
    if (!keepFocus && opener && opener.focus && document.contains(opener)) opener.focus({ preventScroll: true });
  }

  /* ---------- a few pieces, before anything is typed ---------- */
  function showTrending() {
    var slot = part('trending-slot');
    var from = box.getAttribute('data-trending');
    if (trending || !slot || !from) return;
    trending = true;
    fetch(address(from, 'section_id=' + TRENDING), { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('trending'); return r.text(); })
      .then(function (text) {
        var found = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-kksr-trending]');
        if (found && found.children.length) { slot.innerHTML = found.innerHTML; fade(slot); }
        else hideTrending(slot);
      })
      .catch(function () { trending = false; hideTrending(slot); });   // asked again the next time the panel opens
  }
  // its heading goes with it: a heading over nothing promises what is not there
  function hideTrending(slot) {
    var label = slot.previousElementSibling;
    slot.hidden = true;
    if (label && label.classList.contains('kksr__label')) label.hidden = true;
  }

  /* ---------- a word being typed ---------- */
  function rest() {
    asked++;                                          // whatever is still on its way is no longer wanted
    if (pending) { pending.abort(); pending = null; }
    var live = part('live'), foot = part('foot'), idle = part('rest');
    if (live) { live.hidden = true; live.innerHTML = ''; live.classList.remove('is-asking'); }
    if (foot) foot.hidden = true;
    if (idle) idle.hidden = false;
    say('');
  }
  function ask(term) {
    var live = part('live'), foot = part('foot'), idle = part('rest'), all = part('all');
    if (!live) return;
    var turn = ++asked;
    if (pending) pending.abort();
    pending = 'AbortController' in window ? new AbortController() : null;
    var signal = pending ? pending.signal : undefined;
    live.classList.add('is-asking');
    say('Searching…');
    var word = encodeURIComponent(term);
    var found = fetch(address(box.getAttribute('data-suggest'), 'q=' + word + '&resources%5Btype%5D=product,query&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last&section_id=' + FOUND), { signal: signal, headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('found'); return r.text(); });
    // how many there are in all is the search page's to say; if it cannot, the button does without the number
    var count = fetch(address(box.getAttribute('data-search'), 'q=' + word + LAST + '&section_id=' + COUNT), { signal: signal, headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) { var m = /data-kksr-count="(\d+)"/.exec(text); return m ? Number(m[1]) : null; })
      .catch(function () { return null; });

    Promise.all([found, count]).then(function (got) {
      if (turn !== asked) return;                     // a later question has been asked since
      var fresh = new DOMParser().parseFromString(got[0], 'text/html').querySelector('[data-kksr-found]');
      if (!fresh) throw new Error('found');
      live.innerHTML = fresh.innerHTML;
      live.hidden = false;
      fade(live);
      live.classList.remove('is-asking');
      if (idle) idle.hidden = true;
      var shown = live.querySelectorAll('.kksr-card').length;
      var total = got[1];
      // The panel looks for pieces; the search page also finds pages and journal entries.
      // When only those match, the panel must not say nothing was found over a button
      // that says something was.
      var none = live.querySelector('.kksr__none');
      if (none && total > 0) none.textContent = 'No pieces match, but ' + total + (total === 1 ? ' other result does.' : ' other results do.');
      if (foot && all) {
        all.setAttribute('href', address(box.getAttribute('data-search'), 'q=' + word + LAST));
        all.textContent = total ? 'View all ' + total + (total === 1 ? ' result' : ' results') : 'View all results';
        foot.hidden = !(shown > 0 || total > 0);
      }
      if (shown) say(shown + (shown === 1 ? ' product' : ' products') + ' shown' + (total ? ' of ' + total : ''));
      else say(total > 0 ? 'No products; ' + total + (total === 1 ? ' other result' : ' other results') : 'No matches found');
    }).catch(function (err) {
      if (turn !== asked || (err && err.name === 'AbortError')) return;
      // the store could not be asked: the search page itself still can be
      live.classList.remove('is-asking');
      live.innerHTML = '<p class="kksr__none">Press Enter to search.</p>';
      live.hidden = false;
      if (idle) idle.hidden = true;
      if (foot) foot.hidden = true;
      say('');
    });
  }
  function typed() {
    var input = part('input');
    var term = input ? input.value.trim() : '';
    clearTimeout(typing);
    if (!term) { rest(); return; }
    typing = setTimeout(function () { ask(term); }, WAIT);
  }

  /* ---------- the keyboard stays in the panel ---------- */
  function reachable() {
    var p = part('panel');
    if (!p) return [];
    return Array.prototype.slice.call(p.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])'))
      .filter(function (el) { return el.getClientRects().length > 0; });
  }

  document.addEventListener('click', function (e) {
    if (!box || !e.target.closest) return;
    var glass = e.target.closest(GLASS);
    if (glass) {
      // before the theme's own search window hears it
      e.preventDefault();
      e.stopPropagation();
      if (box.classList.contains('is-open')) close(); else open(glass);
      return;
    }
    if (e.target.closest('[data-kksr-close]')) { close(); return; }
    // The bar stays in reach above the panel. Anything else pressed on it (the cart, the
    // menu, the account) opens over the page: the panel is put away first, not left
    // open underneath.
    if (box.classList.contains('is-open') && e.target.closest('.section-header') && !e.target.closest('[data-kksr-panel]')) {
      close(true);
      return;
    }
    if (e.target.closest('[data-kksr-clear]')) {
      var input = part('input');
      if (input) { input.value = ''; input.focus({ preventScroll: true }); }
      rest();
    }
  }, true);
  document.addEventListener('input', function (e) { if (box && e.target === part('input')) typed(); });
  document.addEventListener('submit', function (e) {
    if (!e.target.matches || !e.target.matches('[data-kksr-form], [data-kksh]')) return;
    var input = e.target.querySelector('input[name="q"]');
    if (input && !input.value.trim()) { e.preventDefault(); return; }   // nothing to look for
    // the search page is on its way: what the panel was still asking is no longer wanted
    clearTimeout(typing);
    asked++;
    if (pending) { pending.abort(); pending = null; }
  });
  document.addEventListener('keydown', function (e) {
    if (!box || !box.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = reachable();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], at = document.activeElement;
    if (list.indexOf(at) === -1) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && at === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && at === last) { e.preventDefault(); first.focus(); }
  });
  window.addEventListener('resize', function () { if (box && box.classList.contains('is-open')) place(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(true); });

  /* ---------- the search page ---------- */
  document.addEventListener('click', function (e) {
    var clear = e.target.closest ? e.target.closest('[data-kksh-clear]') : null;
    if (!clear) return;
    var input = clear.form ? clear.form.querySelector('[data-kksh-input]') : null;
    if (input) { input.value = ''; input.focus(); }
  });

  function scan() {
    var found = document.querySelector('[data-kksr]');
    if (found === box) return;
    if (box) mark(false);
    box = found;
    trending = false;
    if (!box) return;
    // the glass now opens a panel, not the theme's search window
    document.querySelectorAll(GLASS).forEach(function (el) {
      el.setAttribute('aria-controls', 'KkSearch');
      el.setAttribute('aria-expanded', 'false');
      el.setAttribute('aria-haspopup', 'dialog');
    });
  }

  window.__kkSearch = { scan: scan, open: open, close: close };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', function () { setTimeout(scan, 0); });
})();
